var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showTabs.length > 0
    ? _c(
        "Tabs",
        {
          attrs: { id: "editTabPanel", type: "card" },
          model: {
            value: _vm.defaultProject,
            callback: function ($$v) {
              _vm.defaultProject = $$v
            },
            expression: "defaultProject",
          },
        },
        [
          _vm.showTabs.indexOf("physicalPackage") > -1
            ? _c(
                "TabPane",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  attrs: { label: "体检套餐", name: "physicalPackage" },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "50%" },
                    attrs: { placeholder: "输入关键字进行过滤", clearable: "" },
                    model: {
                      value: _vm.filterPackageText,
                      callback: function ($$v) {
                        _vm.filterPackageText = $$v
                      },
                      expression: "filterPackageText",
                    },
                  }),
                  _c(
                    "FormItem",
                    {
                      style: { "max-height": "350px", "overflow-y": "auto" },
                      attrs: { "label-width": 0, prop: "packagesIds" },
                    },
                    [
                      _c("el-tree", {
                        ref: "packagesTree",
                        attrs: {
                          data: _vm.physicalPackages,
                          "filter-node-method": _vm.filterNode,
                          "show-checkbox": "",
                          "node-key": "id",
                          "default-checked-keys": [],
                          props: _vm.defaultProps,
                        },
                        on: { "check-change": _vm.packagesIdsCheck },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.showTabs.indexOf("physicalField") > -1
            ? _c(
                "TabPane",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  attrs: { label: "体检数据", name: "physicalField" },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "50%" },
                    attrs: { placeholder: "输入关键字进行过滤", clearable: "" },
                    model: {
                      value: _vm.filterFieldText,
                      callback: function ($$v) {
                        _vm.filterFieldText = $$v
                      },
                      expression: "filterFieldText",
                    },
                  }),
                  _c(
                    "FormItem",
                    {
                      style: { "max-height": "350px", "overflow-y": "auto" },
                      attrs: { "label-width": 0, prop: "fieldIds" },
                    },
                    [
                      _c("el-tree", {
                        ref: "fieldTree",
                        attrs: {
                          data: _vm.physicalFields,
                          "filter-node-method": _vm.filterNode,
                          "show-checkbox": "",
                          "check-strictly": true,
                          "highlight-current": true,
                          "expand-on-click-node": false,
                          "node-key": "id",
                          "default-checked-keys": [],
                          props: _vm.defaultProps,
                        },
                        on: { "check-change": _vm.fieldIdsCheck },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ node, data }) {
                                return _c(
                                  "span",
                                  { staticClass: "custom-tree-node" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "custom-tree-node-content",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(node.label) + "\n            "
                                        ),
                                        data.businessType
                                          ? _c(
                                              "span",
                                              {
                                                style: {
                                                  color:
                                                    _vm.convertBusinessType(
                                                      data.businessType
                                                    ).color,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "--" +
                                                    _vm._s(
                                                      _vm.convertBusinessType(
                                                        data.businessType
                                                      ).name
                                                    )
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                )
                              },
                            },
                          ],
                          null,
                          false,
                          2498028722
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }